export default __webpack_public_path__ + "static/media/search.b41659d4.jpg";